import { Alert } from 'antd'
import { t } from '@/config/translations'
import { branding } from '@/config/branding'
import styles from './DemoBlockedMessage.module.css'

export function DemoBlockedMessage() {
  return (
    <div className={styles['container']}>
      <Alert
        title="Demo limit reached"
        description={
          <span>
            {t('demo_limit_reached')}{' '}
            <a href={`mailto:${branding.supportEmail}`}>{branding.supportEmail}</a>
          </span>
        }
        type="info"
        showIcon
      />
    </div>
  )
}
